'use strict';

var chunkGONKA3OC_js = require('./chunk-GONKA3OC.js');
var encoding = require('@cosmjs/encoding');
var MsgTransferInjective = require('@injectivelabs/sdk-ts/dist/cjs/core/modules/ibc/msgs/MsgTransfer');
var MsgExecuteContractInjective = require('@injectivelabs/sdk-ts/dist/cjs/core/modules/wasm/msgs/MsgExecuteContract');
var tx$2 = require('cosmjs-types/cosmos/bank/v1beta1/tx');
var tx$1 = require('cosmjs-types/cosmwasm/wasm/v1/tx');
var tx = require('cosmjs-types/ibc/applications/transfer/v1/tx');
var _m02 = require('protobufjs/minimal');
var Long = require('long');
require('@keplr-wallet/unit');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var MsgTransferInjective__default = /*#__PURE__*/_interopDefault(MsgTransferInjective);
var MsgExecuteContractInjective__default = /*#__PURE__*/_interopDefault(MsgExecuteContractInjective);
var _m02__namespace = /*#__PURE__*/_interopNamespace(_m02);
var Long__default = /*#__PURE__*/_interopDefault(Long);

if (_m02__namespace.util.Long !== Long__default.default) {
  _m02__namespace.util.Long = Long__default.default;
  _m02__namespace.configure();
}
var globalThis = (() => {
  if (typeof globalThis !== "undefined")
    return globalThis;
  if (typeof self !== "undefined")
    return self;
  if (typeof window !== "undefined")
    return window;
  if (typeof global !== "undefined")
    return global;
  throw "Unable to locate global object";
})();
var atob = globalThis.atob || ((b64) => globalThis.Buffer.from(b64, "base64").toString("binary"));
function bytesFromBase64(b64) {
  const bin = atob(b64);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; ++i) {
    arr[i] = bin.charCodeAt(i);
  }
  return arr;
}
var btoa = globalThis.btoa || ((bin) => globalThis.Buffer.from(bin, "binary").toString("base64"));
function base64FromBytes(arr) {
  const bin = [];
  arr.forEach((byte) => {
    bin.push(String.fromCharCode(byte));
  });
  return btoa(bin.join(""));
}
function isSet(value) {
  return value !== null && value !== void 0;
}
function createBaseMsgUpdateOwner() {
  return {
    from: "",
    newOwner: ""
  };
}
var MsgUpdateOwner = {
  typeUrl: "/circle.cctp.v1.MsgUpdateOwner",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.newOwner !== "") {
      writer.uint32(18).string(message.newOwner);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateOwner();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.newOwner = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      newOwner: isSet(object.newOwner) ? String(object.newOwner) : ""
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.newOwner !== void 0 && (obj.newOwner = message.newOwner);
    return obj;
  },
  fromPartial(object) {
    var _a, _b;
    const message = createBaseMsgUpdateOwner();
    message.from = (_a = object.from) != null ? _a : "";
    message.newOwner = (_b = object.newOwner) != null ? _b : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgUpdateOwner();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.new_owner !== void 0 && object.new_owner !== null) {
      message.newOwner = object.new_owner;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.new_owner = message.newOwner;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgUpdateOwner.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/UpdateOwner",
      value: MsgUpdateOwner.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgUpdateOwner.decode(message.value);
  },
  toProto(message) {
    return MsgUpdateOwner.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgUpdateOwner",
      value: MsgUpdateOwner.encode(message).finish()
    };
  }
};
function createBaseMsgUpdateAttesterManager() {
  return {
    from: "",
    newAttesterManager: ""
  };
}
var MsgUpdateAttesterManager = {
  typeUrl: "/circle.cctp.v1.MsgUpdateAttesterManager",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.newAttesterManager !== "") {
      writer.uint32(18).string(message.newAttesterManager);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateAttesterManager();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.newAttesterManager = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      newAttesterManager: isSet(object.newAttesterManager) ? String(object.newAttesterManager) : ""
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.newAttesterManager !== void 0 && (obj.newAttesterManager = message.newAttesterManager);
    return obj;
  },
  fromPartial(object) {
    var _a, _b;
    const message = createBaseMsgUpdateAttesterManager();
    message.from = (_a = object.from) != null ? _a : "";
    message.newAttesterManager = (_b = object.newAttesterManager) != null ? _b : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgUpdateAttesterManager();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.new_attester_manager !== void 0 && object.new_attester_manager !== null) {
      message.newAttesterManager = object.new_attester_manager;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.new_attester_manager = message.newAttesterManager;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgUpdateAttesterManager.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/UpdateAttesterManager",
      value: MsgUpdateAttesterManager.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgUpdateAttesterManager.decode(message.value);
  },
  toProto(message) {
    return MsgUpdateAttesterManager.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgUpdateAttesterManager",
      value: MsgUpdateAttesterManager.encode(message).finish()
    };
  }
};
function createBaseMsgUpdateTokenController() {
  return {
    from: "",
    newTokenController: ""
  };
}
var MsgUpdateTokenController = {
  typeUrl: "/circle.cctp.v1.MsgUpdateTokenController",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.newTokenController !== "") {
      writer.uint32(18).string(message.newTokenController);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateTokenController();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.newTokenController = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      newTokenController: isSet(object.newTokenController) ? String(object.newTokenController) : ""
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.newTokenController !== void 0 && (obj.newTokenController = message.newTokenController);
    return obj;
  },
  fromPartial(object) {
    var _a, _b;
    const message = createBaseMsgUpdateTokenController();
    message.from = (_a = object.from) != null ? _a : "";
    message.newTokenController = (_b = object.newTokenController) != null ? _b : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgUpdateTokenController();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.new_token_controller !== void 0 && object.new_token_controller !== null) {
      message.newTokenController = object.new_token_controller;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.new_token_controller = message.newTokenController;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgUpdateTokenController.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/UpdateTokenController",
      value: MsgUpdateTokenController.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgUpdateTokenController.decode(message.value);
  },
  toProto(message) {
    return MsgUpdateTokenController.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgUpdateTokenController",
      value: MsgUpdateTokenController.encode(message).finish()
    };
  }
};
function createBaseMsgUpdatePauser() {
  return {
    from: "",
    newPauser: ""
  };
}
var MsgUpdatePauser = {
  typeUrl: "/circle.cctp.v1.MsgUpdatePauser",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.newPauser !== "") {
      writer.uint32(18).string(message.newPauser);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdatePauser();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.newPauser = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      newPauser: isSet(object.newPauser) ? String(object.newPauser) : ""
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.newPauser !== void 0 && (obj.newPauser = message.newPauser);
    return obj;
  },
  fromPartial(object) {
    var _a, _b;
    const message = createBaseMsgUpdatePauser();
    message.from = (_a = object.from) != null ? _a : "";
    message.newPauser = (_b = object.newPauser) != null ? _b : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgUpdatePauser();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.new_pauser !== void 0 && object.new_pauser !== null) {
      message.newPauser = object.new_pauser;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.new_pauser = message.newPauser;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgUpdatePauser.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/UpdatePauser",
      value: MsgUpdatePauser.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgUpdatePauser.decode(message.value);
  },
  toProto(message) {
    return MsgUpdatePauser.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgUpdatePauser",
      value: MsgUpdatePauser.encode(message).finish()
    };
  }
};
function createBaseMsgAcceptOwner() {
  return {
    from: ""
  };
}
var MsgAcceptOwner = {
  typeUrl: "/circle.cctp.v1.MsgAcceptOwner",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgAcceptOwner();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : ""
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    return obj;
  },
  fromPartial(object) {
    var _a;
    const message = createBaseMsgAcceptOwner();
    message.from = (_a = object.from) != null ? _a : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgAcceptOwner();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgAcceptOwner.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/AcceptOwner",
      value: MsgAcceptOwner.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgAcceptOwner.decode(message.value);
  },
  toProto(message) {
    return MsgAcceptOwner.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgAcceptOwner",
      value: MsgAcceptOwner.encode(message).finish()
    };
  }
};
function createBaseMsgEnableAttester() {
  return {
    from: "",
    attester: ""
  };
}
var MsgEnableAttester = {
  typeUrl: "/circle.cctp.v1.MsgEnableAttester",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.attester !== "") {
      writer.uint32(18).string(message.attester);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgEnableAttester();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.attester = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      attester: isSet(object.attester) ? String(object.attester) : ""
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.attester !== void 0 && (obj.attester = message.attester);
    return obj;
  },
  fromPartial(object) {
    var _a, _b;
    const message = createBaseMsgEnableAttester();
    message.from = (_a = object.from) != null ? _a : "";
    message.attester = (_b = object.attester) != null ? _b : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgEnableAttester();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.attester !== void 0 && object.attester !== null) {
      message.attester = object.attester;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.attester = message.attester;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgEnableAttester.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/EnableAttester",
      value: MsgEnableAttester.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgEnableAttester.decode(message.value);
  },
  toProto(message) {
    return MsgEnableAttester.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgEnableAttester",
      value: MsgEnableAttester.encode(message).finish()
    };
  }
};
function createBaseMsgDisableAttester() {
  return {
    from: "",
    attester: ""
  };
}
var MsgDisableAttester = {
  typeUrl: "/circle.cctp.v1.MsgDisableAttester",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.attester !== "") {
      writer.uint32(18).string(message.attester);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgDisableAttester();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.attester = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      attester: isSet(object.attester) ? String(object.attester) : ""
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.attester !== void 0 && (obj.attester = message.attester);
    return obj;
  },
  fromPartial(object) {
    var _a, _b;
    const message = createBaseMsgDisableAttester();
    message.from = (_a = object.from) != null ? _a : "";
    message.attester = (_b = object.attester) != null ? _b : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgDisableAttester();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.attester !== void 0 && object.attester !== null) {
      message.attester = object.attester;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.attester = message.attester;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgDisableAttester.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/DisableAttester",
      value: MsgDisableAttester.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgDisableAttester.decode(message.value);
  },
  toProto(message) {
    return MsgDisableAttester.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgDisableAttester",
      value: MsgDisableAttester.encode(message).finish()
    };
  }
};
function createBaseMsgPauseBurningAndMinting() {
  return {
    from: ""
  };
}
var MsgPauseBurningAndMinting = {
  typeUrl: "/circle.cctp.v1.MsgPauseBurningAndMinting",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgPauseBurningAndMinting();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : ""
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    return obj;
  },
  fromPartial(object) {
    var _a;
    const message = createBaseMsgPauseBurningAndMinting();
    message.from = (_a = object.from) != null ? _a : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgPauseBurningAndMinting();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgPauseBurningAndMinting.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/PauseBurningAndMinting",
      value: MsgPauseBurningAndMinting.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgPauseBurningAndMinting.decode(message.value);
  },
  toProto(message) {
    return MsgPauseBurningAndMinting.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgPauseBurningAndMinting",
      value: MsgPauseBurningAndMinting.encode(message).finish()
    };
  }
};
function createBaseMsgUnpauseBurningAndMinting() {
  return {
    from: ""
  };
}
var MsgUnpauseBurningAndMinting = {
  typeUrl: "/circle.cctp.v1.MsgUnpauseBurningAndMinting",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgUnpauseBurningAndMinting();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : ""
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    return obj;
  },
  fromPartial(object) {
    var _a;
    const message = createBaseMsgUnpauseBurningAndMinting();
    message.from = (_a = object.from) != null ? _a : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgUnpauseBurningAndMinting();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgUnpauseBurningAndMinting.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/UnpauseBurningAndMinting",
      value: MsgUnpauseBurningAndMinting.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgUnpauseBurningAndMinting.decode(message.value);
  },
  toProto(message) {
    return MsgUnpauseBurningAndMinting.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgUnpauseBurningAndMinting",
      value: MsgUnpauseBurningAndMinting.encode(message).finish()
    };
  }
};
function createBaseMsgPauseSendingAndReceivingMessages() {
  return {
    from: ""
  };
}
var MsgPauseSendingAndReceivingMessages = {
  typeUrl: "/circle.cctp.v1.MsgPauseSendingAndReceivingMessages",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgPauseSendingAndReceivingMessages();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : ""
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    return obj;
  },
  fromPartial(object) {
    var _a;
    const message = createBaseMsgPauseSendingAndReceivingMessages();
    message.from = (_a = object.from) != null ? _a : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgPauseSendingAndReceivingMessages();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgPauseSendingAndReceivingMessages.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/PauseSendingAndReceivingMessages",
      value: MsgPauseSendingAndReceivingMessages.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgPauseSendingAndReceivingMessages.decode(message.value);
  },
  toProto(message) {
    return MsgPauseSendingAndReceivingMessages.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgPauseSendingAndReceivingMessages",
      value: MsgPauseSendingAndReceivingMessages.encode(message).finish()
    };
  }
};
function createBaseMsgUnpauseSendingAndReceivingMessages() {
  return {
    from: ""
  };
}
var MsgUnpauseSendingAndReceivingMessages = {
  typeUrl: "/circle.cctp.v1.MsgUnpauseSendingAndReceivingMessages",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgUnpauseSendingAndReceivingMessages();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : ""
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    return obj;
  },
  fromPartial(object) {
    var _a;
    const message = createBaseMsgUnpauseSendingAndReceivingMessages();
    message.from = (_a = object.from) != null ? _a : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgUnpauseSendingAndReceivingMessages();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgUnpauseSendingAndReceivingMessages.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/UnpauseSendingAndReceivingMessages",
      value: MsgUnpauseSendingAndReceivingMessages.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgUnpauseSendingAndReceivingMessages.decode(message.value);
  },
  toProto(message) {
    return MsgUnpauseSendingAndReceivingMessages.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgUnpauseSendingAndReceivingMessages",
      value: MsgUnpauseSendingAndReceivingMessages.encode(message).finish()
    };
  }
};
function createBaseMsgUpdateMaxMessageBodySize() {
  return {
    from: "",
    messageSize: Long__default.default.UZERO
  };
}
var MsgUpdateMaxMessageBodySize = {
  typeUrl: "/circle.cctp.v1.MsgUpdateMaxMessageBodySize",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (!message.messageSize.isZero()) {
      writer.uint32(16).uint64(message.messageSize);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateMaxMessageBodySize();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.messageSize = reader.uint64();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      messageSize: isSet(object.messageSize) ? Long__default.default.fromValue(object.messageSize) : Long__default.default.UZERO
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.messageSize !== void 0 && (obj.messageSize = (message.messageSize || Long__default.default.UZERO).toString());
    return obj;
  },
  fromPartial(object) {
    var _a;
    const message = createBaseMsgUpdateMaxMessageBodySize();
    message.from = (_a = object.from) != null ? _a : "";
    message.messageSize = object.messageSize !== void 0 && object.messageSize !== null ? Long__default.default.fromValue(object.messageSize) : Long__default.default.UZERO;
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgUpdateMaxMessageBodySize();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.message_size !== void 0 && object.message_size !== null) {
      message.messageSize = Long__default.default.fromString(object.message_size);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.message_size = message.messageSize ? message.messageSize.toString() : void 0;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgUpdateMaxMessageBodySize.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/UpdateMaxMessageBodySize",
      value: MsgUpdateMaxMessageBodySize.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgUpdateMaxMessageBodySize.decode(message.value);
  },
  toProto(message) {
    return MsgUpdateMaxMessageBodySize.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgUpdateMaxMessageBodySize",
      value: MsgUpdateMaxMessageBodySize.encode(message).finish()
    };
  }
};
function createBaseMsgSetMaxBurnAmountPerMessage() {
  return {
    from: "",
    localToken: "",
    amount: ""
  };
}
var MsgSetMaxBurnAmountPerMessage = {
  typeUrl: "/circle.cctp.v1.MsgSetMaxBurnAmountPerMessage",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.localToken !== "") {
      writer.uint32(18).string(message.localToken);
    }
    if (message.amount !== "") {
      writer.uint32(26).string(message.amount);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgSetMaxBurnAmountPerMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.localToken = reader.string();
          break;
        case 3:
          message.amount = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      localToken: isSet(object.localToken) ? String(object.localToken) : "",
      amount: isSet(object.amount) ? String(object.amount) : ""
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.localToken !== void 0 && (obj.localToken = message.localToken);
    message.amount !== void 0 && (obj.amount = message.amount);
    return obj;
  },
  fromPartial(object) {
    var _a, _b, _c;
    const message = createBaseMsgSetMaxBurnAmountPerMessage();
    message.from = (_a = object.from) != null ? _a : "";
    message.localToken = (_b = object.localToken) != null ? _b : "";
    message.amount = (_c = object.amount) != null ? _c : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgSetMaxBurnAmountPerMessage();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.local_token !== void 0 && object.local_token !== null) {
      message.localToken = object.local_token;
    }
    if (object.amount !== void 0 && object.amount !== null) {
      message.amount = object.amount;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.local_token = message.localToken;
    obj.amount = message.amount;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgSetMaxBurnAmountPerMessage.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/SetMaxBurnAmountPerMessage",
      value: MsgSetMaxBurnAmountPerMessage.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgSetMaxBurnAmountPerMessage.decode(message.value);
  },
  toProto(message) {
    return MsgSetMaxBurnAmountPerMessage.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgSetMaxBurnAmountPerMessage",
      value: MsgSetMaxBurnAmountPerMessage.encode(message).finish()
    };
  }
};
function createBaseMsgDepositForBurn() {
  return {
    from: "",
    amount: "",
    destinationDomain: 0,
    mintRecipient: new Uint8Array(),
    burnToken: ""
  };
}
var MsgDepositForBurn = {
  typeUrl: "/circle.cctp.v1.MsgDepositForBurn",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.amount !== "") {
      writer.uint32(18).string(message.amount);
    }
    if (message.destinationDomain !== 0) {
      writer.uint32(24).uint32(message.destinationDomain);
    }
    if (message.mintRecipient.length !== 0) {
      writer.uint32(34).bytes(message.mintRecipient);
    }
    if (message.burnToken !== "") {
      writer.uint32(42).string(message.burnToken);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgDepositForBurn();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.amount = reader.string();
          break;
        case 3:
          message.destinationDomain = reader.uint32();
          break;
        case 4:
          message.mintRecipient = reader.bytes();
          break;
        case 5:
          message.burnToken = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      amount: isSet(object.amount) ? String(object.amount) : "",
      destinationDomain: isSet(object.destinationDomain) ? Number(object.destinationDomain) : 0,
      mintRecipient: isSet(object.mintRecipient) ? bytesFromBase64(object.mintRecipient) : new Uint8Array(),
      burnToken: isSet(object.burnToken) ? String(object.burnToken) : ""
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.amount !== void 0 && (obj.amount = message.amount);
    message.destinationDomain !== void 0 && (obj.destinationDomain = Math.round(message.destinationDomain));
    message.mintRecipient !== void 0 && (obj.mintRecipient = base64FromBytes(message.mintRecipient !== void 0 ? message.mintRecipient : new Uint8Array()));
    message.burnToken !== void 0 && (obj.burnToken = message.burnToken);
    return obj;
  },
  fromPartial(object) {
    var _a, _b, _c, _d, _e;
    const message = createBaseMsgDepositForBurn();
    message.from = (_a = object.from) != null ? _a : "";
    message.amount = (_b = object.amount) != null ? _b : "";
    message.destinationDomain = (_c = object.destinationDomain) != null ? _c : 0;
    message.mintRecipient = (_d = object.mintRecipient) != null ? _d : new Uint8Array();
    message.burnToken = (_e = object.burnToken) != null ? _e : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgDepositForBurn();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.amount !== void 0 && object.amount !== null) {
      message.amount = object.amount;
    }
    if (object.destination_domain !== void 0 && object.destination_domain !== null) {
      message.destinationDomain = object.destination_domain;
    }
    if (object.mint_recipient !== void 0 && object.mint_recipient !== null) {
      message.mintRecipient = bytesFromBase64(object.mint_recipient);
    }
    if (object.burn_token !== void 0 && object.burn_token !== null) {
      message.burnToken = object.burn_token;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.amount = message.amount;
    obj.destination_domain = message.destinationDomain;
    obj.mint_recipient = message.mintRecipient ? base64FromBytes(message.mintRecipient) : void 0;
    obj.burn_token = message.burnToken;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgDepositForBurn.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/DepositForBurn",
      value: MsgDepositForBurn.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgDepositForBurn.decode(message.value);
  },
  toProto(message) {
    return MsgDepositForBurn.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgDepositForBurn",
      value: MsgDepositForBurn.encode(message).finish()
    };
  }
};
function createBaseMsgDepositForBurnWithCaller() {
  return {
    from: "",
    amount: "",
    destinationDomain: 0,
    mintRecipient: new Uint8Array(),
    burnToken: "",
    destinationCaller: new Uint8Array()
  };
}
var MsgDepositForBurnWithCaller = {
  typeUrl: "/circle.cctp.v1.MsgDepositForBurnWithCaller",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.amount !== "") {
      writer.uint32(18).string(message.amount);
    }
    if (message.destinationDomain !== 0) {
      writer.uint32(24).uint32(message.destinationDomain);
    }
    if (message.mintRecipient.length !== 0) {
      writer.uint32(34).bytes(message.mintRecipient);
    }
    if (message.burnToken !== "") {
      writer.uint32(42).string(message.burnToken);
    }
    if (message.destinationCaller.length !== 0) {
      writer.uint32(50).bytes(message.destinationCaller);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgDepositForBurnWithCaller();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.amount = reader.string();
          break;
        case 3:
          message.destinationDomain = reader.uint32();
          break;
        case 4:
          message.mintRecipient = reader.bytes();
          break;
        case 5:
          message.burnToken = reader.string();
          break;
        case 6:
          message.destinationCaller = reader.bytes();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      amount: isSet(object.amount) ? String(object.amount) : "",
      destinationDomain: isSet(object.destinationDomain) ? Number(object.destinationDomain) : 0,
      mintRecipient: isSet(object.mintRecipient) ? bytesFromBase64(object.mintRecipient) : new Uint8Array(),
      burnToken: isSet(object.burnToken) ? String(object.burnToken) : "",
      destinationCaller: isSet(object.destinationCaller) ? bytesFromBase64(object.destinationCaller) : new Uint8Array()
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.amount !== void 0 && (obj.amount = message.amount);
    message.destinationDomain !== void 0 && (obj.destinationDomain = Math.round(message.destinationDomain));
    message.mintRecipient !== void 0 && (obj.mintRecipient = base64FromBytes(message.mintRecipient !== void 0 ? message.mintRecipient : new Uint8Array()));
    message.burnToken !== void 0 && (obj.burnToken = message.burnToken);
    message.destinationCaller !== void 0 && (obj.destinationCaller = base64FromBytes(message.destinationCaller !== void 0 ? message.destinationCaller : new Uint8Array()));
    return obj;
  },
  fromPartial(object) {
    var _a, _b, _c, _d, _e, _f;
    const message = createBaseMsgDepositForBurnWithCaller();
    message.from = (_a = object.from) != null ? _a : "";
    message.amount = (_b = object.amount) != null ? _b : "";
    message.destinationDomain = (_c = object.destinationDomain) != null ? _c : 0;
    message.mintRecipient = (_d = object.mintRecipient) != null ? _d : new Uint8Array();
    message.burnToken = (_e = object.burnToken) != null ? _e : "";
    message.destinationCaller = (_f = object.destinationCaller) != null ? _f : new Uint8Array();
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgDepositForBurnWithCaller();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.amount !== void 0 && object.amount !== null) {
      message.amount = object.amount;
    }
    if (object.destination_domain !== void 0 && object.destination_domain !== null) {
      message.destinationDomain = object.destination_domain;
    }
    if (object.mint_recipient !== void 0 && object.mint_recipient !== null) {
      message.mintRecipient = bytesFromBase64(object.mint_recipient);
    }
    if (object.burn_token !== void 0 && object.burn_token !== null) {
      message.burnToken = object.burn_token;
    }
    if (object.destination_caller !== void 0 && object.destination_caller !== null) {
      message.destinationCaller = bytesFromBase64(object.destination_caller);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.amount = message.amount;
    obj.destination_domain = message.destinationDomain;
    obj.mint_recipient = message.mintRecipient ? base64FromBytes(message.mintRecipient) : void 0;
    obj.burn_token = message.burnToken;
    obj.destination_caller = message.destinationCaller ? base64FromBytes(message.destinationCaller) : void 0;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgDepositForBurnWithCaller.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/DepositForBurnWithCaller",
      value: MsgDepositForBurnWithCaller.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgDepositForBurnWithCaller.decode(message.value);
  },
  toProto(message) {
    return MsgDepositForBurnWithCaller.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgDepositForBurnWithCaller",
      value: MsgDepositForBurnWithCaller.encode(message).finish()
    };
  }
};
function createBaseMsgReplaceDepositForBurn() {
  return {
    from: "",
    originalMessage: new Uint8Array(),
    originalAttestation: new Uint8Array(),
    newDestinationCaller: new Uint8Array(),
    newMintRecipient: new Uint8Array()
  };
}
var MsgReplaceDepositForBurn = {
  typeUrl: "/circle.cctp.v1.MsgReplaceDepositForBurn",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.originalMessage.length !== 0) {
      writer.uint32(18).bytes(message.originalMessage);
    }
    if (message.originalAttestation.length !== 0) {
      writer.uint32(26).bytes(message.originalAttestation);
    }
    if (message.newDestinationCaller.length !== 0) {
      writer.uint32(34).bytes(message.newDestinationCaller);
    }
    if (message.newMintRecipient.length !== 0) {
      writer.uint32(42).bytes(message.newMintRecipient);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgReplaceDepositForBurn();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.originalMessage = reader.bytes();
          break;
        case 3:
          message.originalAttestation = reader.bytes();
          break;
        case 4:
          message.newDestinationCaller = reader.bytes();
          break;
        case 5:
          message.newMintRecipient = reader.bytes();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      originalMessage: isSet(object.originalMessage) ? bytesFromBase64(object.originalMessage) : new Uint8Array(),
      originalAttestation: isSet(object.originalAttestation) ? bytesFromBase64(object.originalAttestation) : new Uint8Array(),
      newDestinationCaller: isSet(object.newDestinationCaller) ? bytesFromBase64(object.newDestinationCaller) : new Uint8Array(),
      newMintRecipient: isSet(object.newMintRecipient) ? bytesFromBase64(object.newMintRecipient) : new Uint8Array()
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.originalMessage !== void 0 && (obj.originalMessage = base64FromBytes(message.originalMessage !== void 0 ? message.originalMessage : new Uint8Array()));
    message.originalAttestation !== void 0 && (obj.originalAttestation = base64FromBytes(message.originalAttestation !== void 0 ? message.originalAttestation : new Uint8Array()));
    message.newDestinationCaller !== void 0 && (obj.newDestinationCaller = base64FromBytes(message.newDestinationCaller !== void 0 ? message.newDestinationCaller : new Uint8Array()));
    message.newMintRecipient !== void 0 && (obj.newMintRecipient = base64FromBytes(message.newMintRecipient !== void 0 ? message.newMintRecipient : new Uint8Array()));
    return obj;
  },
  fromPartial(object) {
    var _a, _b, _c, _d, _e;
    const message = createBaseMsgReplaceDepositForBurn();
    message.from = (_a = object.from) != null ? _a : "";
    message.originalMessage = (_b = object.originalMessage) != null ? _b : new Uint8Array();
    message.originalAttestation = (_c = object.originalAttestation) != null ? _c : new Uint8Array();
    message.newDestinationCaller = (_d = object.newDestinationCaller) != null ? _d : new Uint8Array();
    message.newMintRecipient = (_e = object.newMintRecipient) != null ? _e : new Uint8Array();
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgReplaceDepositForBurn();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.original_message !== void 0 && object.original_message !== null) {
      message.originalMessage = bytesFromBase64(object.original_message);
    }
    if (object.original_attestation !== void 0 && object.original_attestation !== null) {
      message.originalAttestation = bytesFromBase64(object.original_attestation);
    }
    if (object.new_destination_caller !== void 0 && object.new_destination_caller !== null) {
      message.newDestinationCaller = bytesFromBase64(object.new_destination_caller);
    }
    if (object.new_mint_recipient !== void 0 && object.new_mint_recipient !== null) {
      message.newMintRecipient = bytesFromBase64(object.new_mint_recipient);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.original_message = message.originalMessage ? base64FromBytes(message.originalMessage) : void 0;
    obj.original_attestation = message.originalAttestation ? base64FromBytes(message.originalAttestation) : void 0;
    obj.new_destination_caller = message.newDestinationCaller ? base64FromBytes(message.newDestinationCaller) : void 0;
    obj.new_mint_recipient = message.newMintRecipient ? base64FromBytes(message.newMintRecipient) : void 0;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgReplaceDepositForBurn.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/ReplaceDepositForBurn",
      value: MsgReplaceDepositForBurn.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgReplaceDepositForBurn.decode(message.value);
  },
  toProto(message) {
    return MsgReplaceDepositForBurn.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgReplaceDepositForBurn",
      value: MsgReplaceDepositForBurn.encode(message).finish()
    };
  }
};
function createBaseMsgReceiveMessage() {
  return {
    from: "",
    message: new Uint8Array(),
    attestation: new Uint8Array()
  };
}
var MsgReceiveMessage = {
  typeUrl: "/circle.cctp.v1.MsgReceiveMessage",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.message.length !== 0) {
      writer.uint32(18).bytes(message.message);
    }
    if (message.attestation.length !== 0) {
      writer.uint32(26).bytes(message.attestation);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgReceiveMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.message = reader.bytes();
          break;
        case 3:
          message.attestation = reader.bytes();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      message: isSet(object.message) ? bytesFromBase64(object.message) : new Uint8Array(),
      attestation: isSet(object.attestation) ? bytesFromBase64(object.attestation) : new Uint8Array()
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.message !== void 0 && (obj.message = base64FromBytes(message.message !== void 0 ? message.message : new Uint8Array()));
    message.attestation !== void 0 && (obj.attestation = base64FromBytes(message.attestation !== void 0 ? message.attestation : new Uint8Array()));
    return obj;
  },
  fromPartial(object) {
    var _a, _b, _c;
    const message = createBaseMsgReceiveMessage();
    message.from = (_a = object.from) != null ? _a : "";
    message.message = (_b = object.message) != null ? _b : new Uint8Array();
    message.attestation = (_c = object.attestation) != null ? _c : new Uint8Array();
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgReceiveMessage();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.message !== void 0 && object.message !== null) {
      message.message = bytesFromBase64(object.message);
    }
    if (object.attestation !== void 0 && object.attestation !== null) {
      message.attestation = bytesFromBase64(object.attestation);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.message = message.message ? base64FromBytes(message.message) : void 0;
    obj.attestation = message.attestation ? base64FromBytes(message.attestation) : void 0;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgReceiveMessage.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/ReceiveMessage",
      value: MsgReceiveMessage.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgReceiveMessage.decode(message.value);
  },
  toProto(message) {
    return MsgReceiveMessage.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgReceiveMessage",
      value: MsgReceiveMessage.encode(message).finish()
    };
  }
};
function createBaseMsgSendMessage() {
  return {
    from: "",
    destinationDomain: 0,
    recipient: new Uint8Array(),
    messageBody: new Uint8Array()
  };
}
var MsgSendMessage = {
  typeUrl: "/circle.cctp.v1.MsgSendMessage",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.destinationDomain !== 0) {
      writer.uint32(16).uint32(message.destinationDomain);
    }
    if (message.recipient.length !== 0) {
      writer.uint32(26).bytes(message.recipient);
    }
    if (message.messageBody.length !== 0) {
      writer.uint32(34).bytes(message.messageBody);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgSendMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.destinationDomain = reader.uint32();
          break;
        case 3:
          message.recipient = reader.bytes();
          break;
        case 4:
          message.messageBody = reader.bytes();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      destinationDomain: isSet(object.destinationDomain) ? Number(object.destinationDomain) : 0,
      recipient: isSet(object.recipient) ? bytesFromBase64(object.recipient) : new Uint8Array(),
      messageBody: isSet(object.messageBody) ? bytesFromBase64(object.messageBody) : new Uint8Array()
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.destinationDomain !== void 0 && (obj.destinationDomain = Math.round(message.destinationDomain));
    message.recipient !== void 0 && (obj.recipient = base64FromBytes(message.recipient !== void 0 ? message.recipient : new Uint8Array()));
    message.messageBody !== void 0 && (obj.messageBody = base64FromBytes(message.messageBody !== void 0 ? message.messageBody : new Uint8Array()));
    return obj;
  },
  fromPartial(object) {
    var _a, _b, _c, _d;
    const message = createBaseMsgSendMessage();
    message.from = (_a = object.from) != null ? _a : "";
    message.destinationDomain = (_b = object.destinationDomain) != null ? _b : 0;
    message.recipient = (_c = object.recipient) != null ? _c : new Uint8Array();
    message.messageBody = (_d = object.messageBody) != null ? _d : new Uint8Array();
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgSendMessage();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.destination_domain !== void 0 && object.destination_domain !== null) {
      message.destinationDomain = object.destination_domain;
    }
    if (object.recipient !== void 0 && object.recipient !== null) {
      message.recipient = bytesFromBase64(object.recipient);
    }
    if (object.message_body !== void 0 && object.message_body !== null) {
      message.messageBody = bytesFromBase64(object.message_body);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.destination_domain = message.destinationDomain;
    obj.recipient = message.recipient ? base64FromBytes(message.recipient) : void 0;
    obj.message_body = message.messageBody ? base64FromBytes(message.messageBody) : void 0;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgSendMessage.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/SendMessage",
      value: MsgSendMessage.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgSendMessage.decode(message.value);
  },
  toProto(message) {
    return MsgSendMessage.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgSendMessage",
      value: MsgSendMessage.encode(message).finish()
    };
  }
};
function createBaseMsgSendMessageWithCaller() {
  return {
    from: "",
    destinationDomain: 0,
    recipient: new Uint8Array(),
    messageBody: new Uint8Array(),
    destinationCaller: new Uint8Array()
  };
}
var MsgSendMessageWithCaller = {
  typeUrl: "/circle.cctp.v1.MsgSendMessageWithCaller",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.destinationDomain !== 0) {
      writer.uint32(16).uint32(message.destinationDomain);
    }
    if (message.recipient.length !== 0) {
      writer.uint32(26).bytes(message.recipient);
    }
    if (message.messageBody.length !== 0) {
      writer.uint32(34).bytes(message.messageBody);
    }
    if (message.destinationCaller.length !== 0) {
      writer.uint32(42).bytes(message.destinationCaller);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgSendMessageWithCaller();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.destinationDomain = reader.uint32();
          break;
        case 3:
          message.recipient = reader.bytes();
          break;
        case 4:
          message.messageBody = reader.bytes();
          break;
        case 5:
          message.destinationCaller = reader.bytes();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      destinationDomain: isSet(object.destinationDomain) ? Number(object.destinationDomain) : 0,
      recipient: isSet(object.recipient) ? bytesFromBase64(object.recipient) : new Uint8Array(),
      messageBody: isSet(object.messageBody) ? bytesFromBase64(object.messageBody) : new Uint8Array(),
      destinationCaller: isSet(object.destinationCaller) ? bytesFromBase64(object.destinationCaller) : new Uint8Array()
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.destinationDomain !== void 0 && (obj.destinationDomain = Math.round(message.destinationDomain));
    message.recipient !== void 0 && (obj.recipient = base64FromBytes(message.recipient !== void 0 ? message.recipient : new Uint8Array()));
    message.messageBody !== void 0 && (obj.messageBody = base64FromBytes(message.messageBody !== void 0 ? message.messageBody : new Uint8Array()));
    message.destinationCaller !== void 0 && (obj.destinationCaller = base64FromBytes(message.destinationCaller !== void 0 ? message.destinationCaller : new Uint8Array()));
    return obj;
  },
  fromPartial(object) {
    var _a, _b, _c, _d, _e;
    const message = createBaseMsgSendMessageWithCaller();
    message.from = (_a = object.from) != null ? _a : "";
    message.destinationDomain = (_b = object.destinationDomain) != null ? _b : 0;
    message.recipient = (_c = object.recipient) != null ? _c : new Uint8Array();
    message.messageBody = (_d = object.messageBody) != null ? _d : new Uint8Array();
    message.destinationCaller = (_e = object.destinationCaller) != null ? _e : new Uint8Array();
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgSendMessageWithCaller();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.destination_domain !== void 0 && object.destination_domain !== null) {
      message.destinationDomain = object.destination_domain;
    }
    if (object.recipient !== void 0 && object.recipient !== null) {
      message.recipient = bytesFromBase64(object.recipient);
    }
    if (object.message_body !== void 0 && object.message_body !== null) {
      message.messageBody = bytesFromBase64(object.message_body);
    }
    if (object.destination_caller !== void 0 && object.destination_caller !== null) {
      message.destinationCaller = bytesFromBase64(object.destination_caller);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.destination_domain = message.destinationDomain;
    obj.recipient = message.recipient ? base64FromBytes(message.recipient) : void 0;
    obj.message_body = message.messageBody ? base64FromBytes(message.messageBody) : void 0;
    obj.destination_caller = message.destinationCaller ? base64FromBytes(message.destinationCaller) : void 0;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgSendMessageWithCaller.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/SendMessageWithCaller",
      value: MsgSendMessageWithCaller.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgSendMessageWithCaller.decode(message.value);
  },
  toProto(message) {
    return MsgSendMessageWithCaller.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgSendMessageWithCaller",
      value: MsgSendMessageWithCaller.encode(message).finish()
    };
  }
};
function createBaseMsgReplaceMessage() {
  return {
    from: "",
    originalMessage: new Uint8Array(),
    originalAttestation: new Uint8Array(),
    newMessageBody: new Uint8Array(),
    newDestinationCaller: new Uint8Array()
  };
}
var MsgReplaceMessage = {
  typeUrl: "/circle.cctp.v1.MsgReplaceMessage",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.originalMessage.length !== 0) {
      writer.uint32(18).bytes(message.originalMessage);
    }
    if (message.originalAttestation.length !== 0) {
      writer.uint32(26).bytes(message.originalAttestation);
    }
    if (message.newMessageBody.length !== 0) {
      writer.uint32(34).bytes(message.newMessageBody);
    }
    if (message.newDestinationCaller.length !== 0) {
      writer.uint32(42).bytes(message.newDestinationCaller);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgReplaceMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.originalMessage = reader.bytes();
          break;
        case 3:
          message.originalAttestation = reader.bytes();
          break;
        case 4:
          message.newMessageBody = reader.bytes();
          break;
        case 5:
          message.newDestinationCaller = reader.bytes();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      originalMessage: isSet(object.originalMessage) ? bytesFromBase64(object.originalMessage) : new Uint8Array(),
      originalAttestation: isSet(object.originalAttestation) ? bytesFromBase64(object.originalAttestation) : new Uint8Array(),
      newMessageBody: isSet(object.newMessageBody) ? bytesFromBase64(object.newMessageBody) : new Uint8Array(),
      newDestinationCaller: isSet(object.newDestinationCaller) ? bytesFromBase64(object.newDestinationCaller) : new Uint8Array()
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.originalMessage !== void 0 && (obj.originalMessage = base64FromBytes(message.originalMessage !== void 0 ? message.originalMessage : new Uint8Array()));
    message.originalAttestation !== void 0 && (obj.originalAttestation = base64FromBytes(message.originalAttestation !== void 0 ? message.originalAttestation : new Uint8Array()));
    message.newMessageBody !== void 0 && (obj.newMessageBody = base64FromBytes(message.newMessageBody !== void 0 ? message.newMessageBody : new Uint8Array()));
    message.newDestinationCaller !== void 0 && (obj.newDestinationCaller = base64FromBytes(message.newDestinationCaller !== void 0 ? message.newDestinationCaller : new Uint8Array()));
    return obj;
  },
  fromPartial(object) {
    var _a, _b, _c, _d, _e;
    const message = createBaseMsgReplaceMessage();
    message.from = (_a = object.from) != null ? _a : "";
    message.originalMessage = (_b = object.originalMessage) != null ? _b : new Uint8Array();
    message.originalAttestation = (_c = object.originalAttestation) != null ? _c : new Uint8Array();
    message.newMessageBody = (_d = object.newMessageBody) != null ? _d : new Uint8Array();
    message.newDestinationCaller = (_e = object.newDestinationCaller) != null ? _e : new Uint8Array();
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgReplaceMessage();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.original_message !== void 0 && object.original_message !== null) {
      message.originalMessage = bytesFromBase64(object.original_message);
    }
    if (object.original_attestation !== void 0 && object.original_attestation !== null) {
      message.originalAttestation = bytesFromBase64(object.original_attestation);
    }
    if (object.new_message_body !== void 0 && object.new_message_body !== null) {
      message.newMessageBody = bytesFromBase64(object.new_message_body);
    }
    if (object.new_destination_caller !== void 0 && object.new_destination_caller !== null) {
      message.newDestinationCaller = bytesFromBase64(object.new_destination_caller);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.original_message = message.originalMessage ? base64FromBytes(message.originalMessage) : void 0;
    obj.original_attestation = message.originalAttestation ? base64FromBytes(message.originalAttestation) : void 0;
    obj.new_message_body = message.newMessageBody ? base64FromBytes(message.newMessageBody) : void 0;
    obj.new_destination_caller = message.newDestinationCaller ? base64FromBytes(message.newDestinationCaller) : void 0;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgReplaceMessage.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/ReplaceMessage",
      value: MsgReplaceMessage.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgReplaceMessage.decode(message.value);
  },
  toProto(message) {
    return MsgReplaceMessage.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgReplaceMessage",
      value: MsgReplaceMessage.encode(message).finish()
    };
  }
};
function createBaseMsgUpdateSignatureThreshold() {
  return {
    from: "",
    amount: 0
  };
}
var MsgUpdateSignatureThreshold = {
  typeUrl: "/circle.cctp.v1.MsgUpdateSignatureThreshold",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.amount !== 0) {
      writer.uint32(16).uint32(message.amount);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateSignatureThreshold();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.amount = reader.uint32();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      amount: isSet(object.amount) ? Number(object.amount) : 0
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.amount !== void 0 && (obj.amount = Math.round(message.amount));
    return obj;
  },
  fromPartial(object) {
    var _a, _b;
    const message = createBaseMsgUpdateSignatureThreshold();
    message.from = (_a = object.from) != null ? _a : "";
    message.amount = (_b = object.amount) != null ? _b : 0;
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgUpdateSignatureThreshold();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.amount !== void 0 && object.amount !== null) {
      message.amount = object.amount;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.amount = message.amount;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgUpdateSignatureThreshold.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/UpdateSignatureThreshold",
      value: MsgUpdateSignatureThreshold.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgUpdateSignatureThreshold.decode(message.value);
  },
  toProto(message) {
    return MsgUpdateSignatureThreshold.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgUpdateSignatureThreshold",
      value: MsgUpdateSignatureThreshold.encode(message).finish()
    };
  }
};
function createBaseMsgLinkTokenPair() {
  return {
    from: "",
    remoteDomain: 0,
    remoteToken: new Uint8Array(),
    localToken: ""
  };
}
var MsgLinkTokenPair = {
  typeUrl: "/circle.cctp.v1.MsgLinkTokenPair",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.remoteDomain !== 0) {
      writer.uint32(16).uint32(message.remoteDomain);
    }
    if (message.remoteToken.length !== 0) {
      writer.uint32(26).bytes(message.remoteToken);
    }
    if (message.localToken !== "") {
      writer.uint32(34).string(message.localToken);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgLinkTokenPair();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.remoteDomain = reader.uint32();
          break;
        case 3:
          message.remoteToken = reader.bytes();
          break;
        case 4:
          message.localToken = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      remoteDomain: isSet(object.remoteDomain) ? Number(object.remoteDomain) : 0,
      remoteToken: isSet(object.remoteToken) ? bytesFromBase64(object.remoteToken) : new Uint8Array(),
      localToken: isSet(object.localToken) ? String(object.localToken) : ""
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.remoteDomain !== void 0 && (obj.remoteDomain = Math.round(message.remoteDomain));
    message.remoteToken !== void 0 && (obj.remoteToken = base64FromBytes(message.remoteToken !== void 0 ? message.remoteToken : new Uint8Array()));
    message.localToken !== void 0 && (obj.localToken = message.localToken);
    return obj;
  },
  fromPartial(object) {
    var _a, _b, _c, _d;
    const message = createBaseMsgLinkTokenPair();
    message.from = (_a = object.from) != null ? _a : "";
    message.remoteDomain = (_b = object.remoteDomain) != null ? _b : 0;
    message.remoteToken = (_c = object.remoteToken) != null ? _c : new Uint8Array();
    message.localToken = (_d = object.localToken) != null ? _d : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgLinkTokenPair();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.remote_domain !== void 0 && object.remote_domain !== null) {
      message.remoteDomain = object.remote_domain;
    }
    if (object.remote_token !== void 0 && object.remote_token !== null) {
      message.remoteToken = bytesFromBase64(object.remote_token);
    }
    if (object.local_token !== void 0 && object.local_token !== null) {
      message.localToken = object.local_token;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.remote_domain = message.remoteDomain;
    obj.remote_token = message.remoteToken ? base64FromBytes(message.remoteToken) : void 0;
    obj.local_token = message.localToken;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgLinkTokenPair.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/LinkTokenPair",
      value: MsgLinkTokenPair.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgLinkTokenPair.decode(message.value);
  },
  toProto(message) {
    return MsgLinkTokenPair.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgLinkTokenPair",
      value: MsgLinkTokenPair.encode(message).finish()
    };
  }
};
function createBaseMsgUnlinkTokenPair() {
  return {
    from: "",
    remoteDomain: 0,
    remoteToken: new Uint8Array(),
    localToken: ""
  };
}
var MsgUnlinkTokenPair = {
  typeUrl: "/circle.cctp.v1.MsgUnlinkTokenPair",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.remoteDomain !== 0) {
      writer.uint32(16).uint32(message.remoteDomain);
    }
    if (message.remoteToken.length !== 0) {
      writer.uint32(26).bytes(message.remoteToken);
    }
    if (message.localToken !== "") {
      writer.uint32(34).string(message.localToken);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgUnlinkTokenPair();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.remoteDomain = reader.uint32();
          break;
        case 3:
          message.remoteToken = reader.bytes();
          break;
        case 4:
          message.localToken = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      remoteDomain: isSet(object.remoteDomain) ? Number(object.remoteDomain) : 0,
      remoteToken: isSet(object.remoteToken) ? bytesFromBase64(object.remoteToken) : new Uint8Array(),
      localToken: isSet(object.localToken) ? String(object.localToken) : ""
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.remoteDomain !== void 0 && (obj.remoteDomain = Math.round(message.remoteDomain));
    message.remoteToken !== void 0 && (obj.remoteToken = base64FromBytes(message.remoteToken !== void 0 ? message.remoteToken : new Uint8Array()));
    message.localToken !== void 0 && (obj.localToken = message.localToken);
    return obj;
  },
  fromPartial(object) {
    var _a, _b, _c, _d;
    const message = createBaseMsgUnlinkTokenPair();
    message.from = (_a = object.from) != null ? _a : "";
    message.remoteDomain = (_b = object.remoteDomain) != null ? _b : 0;
    message.remoteToken = (_c = object.remoteToken) != null ? _c : new Uint8Array();
    message.localToken = (_d = object.localToken) != null ? _d : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgUnlinkTokenPair();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.remote_domain !== void 0 && object.remote_domain !== null) {
      message.remoteDomain = object.remote_domain;
    }
    if (object.remote_token !== void 0 && object.remote_token !== null) {
      message.remoteToken = bytesFromBase64(object.remote_token);
    }
    if (object.local_token !== void 0 && object.local_token !== null) {
      message.localToken = object.local_token;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.remote_domain = message.remoteDomain;
    obj.remote_token = message.remoteToken ? base64FromBytes(message.remoteToken) : void 0;
    obj.local_token = message.localToken;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgUnlinkTokenPair.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/UnlinkTokenPair",
      value: MsgUnlinkTokenPair.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgUnlinkTokenPair.decode(message.value);
  },
  toProto(message) {
    return MsgUnlinkTokenPair.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgUnlinkTokenPair",
      value: MsgUnlinkTokenPair.encode(message).finish()
    };
  }
};
function createBaseMsgAddRemoteTokenMessenger() {
  return {
    from: "",
    domainId: 0,
    address: new Uint8Array()
  };
}
var MsgAddRemoteTokenMessenger = {
  typeUrl: "/circle.cctp.v1.MsgAddRemoteTokenMessenger",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.domainId !== 0) {
      writer.uint32(16).uint32(message.domainId);
    }
    if (message.address.length !== 0) {
      writer.uint32(26).bytes(message.address);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgAddRemoteTokenMessenger();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.domainId = reader.uint32();
          break;
        case 3:
          message.address = reader.bytes();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      domainId: isSet(object.domainId) ? Number(object.domainId) : 0,
      address: isSet(object.address) ? bytesFromBase64(object.address) : new Uint8Array()
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.domainId !== void 0 && (obj.domainId = Math.round(message.domainId));
    message.address !== void 0 && (obj.address = base64FromBytes(message.address !== void 0 ? message.address : new Uint8Array()));
    return obj;
  },
  fromPartial(object) {
    var _a, _b, _c;
    const message = createBaseMsgAddRemoteTokenMessenger();
    message.from = (_a = object.from) != null ? _a : "";
    message.domainId = (_b = object.domainId) != null ? _b : 0;
    message.address = (_c = object.address) != null ? _c : new Uint8Array();
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgAddRemoteTokenMessenger();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.domain_id !== void 0 && object.domain_id !== null) {
      message.domainId = object.domain_id;
    }
    if (object.address !== void 0 && object.address !== null) {
      message.address = bytesFromBase64(object.address);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.domain_id = message.domainId;
    obj.address = message.address ? base64FromBytes(message.address) : void 0;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgAddRemoteTokenMessenger.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/AddRemoteTokenMessenger",
      value: MsgAddRemoteTokenMessenger.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgAddRemoteTokenMessenger.decode(message.value);
  },
  toProto(message) {
    return MsgAddRemoteTokenMessenger.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgAddRemoteTokenMessenger",
      value: MsgAddRemoteTokenMessenger.encode(message).finish()
    };
  }
};
function createBaseMsgRemoveRemoteTokenMessenger() {
  return {
    from: "",
    domainId: 0
  };
}
var MsgRemoveRemoteTokenMessenger = {
  typeUrl: "/circle.cctp.v1.MsgRemoveRemoteTokenMessenger",
  encode(message, writer = _m02__namespace.Writer.create()) {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.domainId !== 0) {
      writer.uint32(16).uint32(message.domainId);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m02__namespace.Reader ? input : new _m02__namespace.Reader(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseMsgRemoveRemoteTokenMessenger();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.from = reader.string();
          break;
        case 2:
          message.domainId = reader.uint32();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      from: isSet(object.from) ? String(object.from) : "",
      domainId: isSet(object.domainId) ? Number(object.domainId) : 0
    };
  },
  toJSON(message) {
    const obj = {};
    message.from !== void 0 && (obj.from = message.from);
    message.domainId !== void 0 && (obj.domainId = Math.round(message.domainId));
    return obj;
  },
  fromPartial(object) {
    var _a, _b;
    const message = createBaseMsgRemoveRemoteTokenMessenger();
    message.from = (_a = object.from) != null ? _a : "";
    message.domainId = (_b = object.domainId) != null ? _b : 0;
    return message;
  },
  fromAmino(object) {
    const message = createBaseMsgRemoveRemoteTokenMessenger();
    if (object.from !== void 0 && object.from !== null) {
      message.from = object.from;
    }
    if (object.domain_id !== void 0 && object.domain_id !== null) {
      message.domainId = object.domain_id;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.from = message.from;
    obj.domain_id = message.domainId;
    return obj;
  },
  fromAminoMsg(object) {
    return MsgRemoveRemoteTokenMessenger.fromAmino(object.value);
  },
  toAminoMsg(message) {
    return {
      type: "cctp/RemoveRemoteTokenMessenger",
      value: MsgRemoveRemoteTokenMessenger.toAmino(message)
    };
  },
  fromProtoMsg(message) {
    return MsgRemoveRemoteTokenMessenger.decode(message.value);
  },
  toProto(message) {
    return MsgRemoveRemoteTokenMessenger.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/circle.cctp.v1.MsgRemoveRemoteTokenMessenger",
      value: MsgRemoveRemoteTokenMessenger.encode(message).finish()
    };
  }
};

// src/transactions.ts
var DEFAULT_GAS_MULTIPLIER = 1.5;
function getEncodeObjectFromCosmosMessage(message) {
  const msgJson = JSON.parse(message.msg);
  if (message.msgTypeURL === "/ibc.applications.transfer.v1.MsgTransfer") {
    return {
      typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
      value: tx.MsgTransfer.fromJSON({
        sourcePort: msgJson.source_port,
        sourceChannel: msgJson.source_channel,
        token: msgJson.token,
        sender: msgJson.sender,
        receiver: msgJson.receiver,
        timeoutHeight: msgJson.timeout_height,
        timeoutTimestamp: msgJson.timeout_timestamp,
        memo: msgJson.memo
      })
    };
  }
  if (message.msgTypeURL === "/cosmwasm.wasm.v1.MsgExecuteContract") {
    return {
      typeUrl: message.msgTypeURL,
      value: tx$1.MsgExecuteContract.fromPartial({
        sender: msgJson.sender,
        contract: msgJson.contract,
        msg: encoding.toUtf8(JSON.stringify(msgJson.msg)),
        funds: msgJson.funds
      })
    };
  }
  if (message.msgTypeURL === "/cosmos.bank.v1beta1.MsgSend") {
    return {
      typeUrl: message.msgTypeURL,
      value: tx$2.MsgSend.fromPartial({
        fromAddress: msgJson.from_address,
        toAddress: msgJson.to_address,
        amount: msgJson.amount
      })
    };
  }
  if (message.msgTypeURL === "/circle.cctp.v1.MsgDepositForBurn") {
    return {
      typeUrl: message.msgTypeURL,
      value: MsgDepositForBurn.fromAmino(msgJson)
    };
  }
  if (message.msgTypeURL === "/circle.cctp.v1.MsgDepositForBurnWithCaller") {
    return {
      typeUrl: message.msgTypeURL,
      value: MsgDepositForBurnWithCaller.fromAmino(msgJson)
    };
  }
  return {
    typeUrl: message.msgTypeURL,
    value: msgJson
  };
}
function getEncodeObjectFromCosmosMessageInjective(message) {
  const msgJson = JSON.parse(message.msg);
  if (message.msgTypeURL === "/ibc.applications.transfer.v1.MsgTransfer") {
    return MsgTransferInjective__default.default.fromJSON({
      port: msgJson.source_port,
      channelId: msgJson.source_channel,
      amount: msgJson.token,
      sender: msgJson.sender,
      receiver: msgJson.receiver,
      timeout: msgJson.timeout_timestamp,
      memo: msgJson.memo
    });
  }
  if (message.msgTypeURL === "/cosmwasm.wasm.v1.MsgExecuteContract") {
    return MsgExecuteContractInjective__default.default.fromJSON({
      sender: msgJson.sender,
      contractAddress: msgJson.contract,
      msg: msgJson.msg,
      funds: msgJson.funds
    });
  }
  throw new Error("Unsupported message type");
}
function getCosmosGasAmountForMessage(_0, _1, _2, _3, _4) {
  return chunkGONKA3OC_js.__async(this, arguments, function* (client, signerAddress, chainID, messages, encodedMsgs, multiplier = DEFAULT_GAS_MULTIPLIER) {
    if (!messages && !encodedMsgs) {
      throw new Error("Either message or encodedMsg must be provided");
    }
    const _encodedMsgs = messages == null ? void 0 : messages.map(
      (message) => getEncodeObjectFromCosmosMessage(message)
    );
    encodedMsgs = encodedMsgs || _encodedMsgs;
    if (!encodedMsgs) {
      throw new Error("Either message or encodedMsg must be provided");
    }
    if (chainID.includes("evmos") || chainID.includes("injective") || chainID.includes("dymension") || (process == null ? void 0 : process.env.NODE_ENV) === "test") {
      if (messages == null ? void 0 : messages.find(
        (i) => i.msgTypeURL === "/cosmwasm.wasm.v1.MsgExecuteContract"
      )) {
        return "2400000";
      }
      return "280000";
    }
    const estimatedGas = yield client.simulate(signerAddress, encodedMsgs, "");
    const estimatedGasWithBuffer = estimatedGas * multiplier;
    return Math.ceil(estimatedGasWithBuffer).toFixed(0);
  });
}

exports.DEFAULT_GAS_MULTIPLIER = DEFAULT_GAS_MULTIPLIER;
exports.MsgAcceptOwner = MsgAcceptOwner;
exports.MsgAddRemoteTokenMessenger = MsgAddRemoteTokenMessenger;
exports.MsgDepositForBurn = MsgDepositForBurn;
exports.MsgDepositForBurnWithCaller = MsgDepositForBurnWithCaller;
exports.MsgDisableAttester = MsgDisableAttester;
exports.MsgEnableAttester = MsgEnableAttester;
exports.MsgLinkTokenPair = MsgLinkTokenPair;
exports.MsgPauseBurningAndMinting = MsgPauseBurningAndMinting;
exports.MsgPauseSendingAndReceivingMessages = MsgPauseSendingAndReceivingMessages;
exports.MsgReceiveMessage = MsgReceiveMessage;
exports.MsgRemoveRemoteTokenMessenger = MsgRemoveRemoteTokenMessenger;
exports.MsgReplaceDepositForBurn = MsgReplaceDepositForBurn;
exports.MsgReplaceMessage = MsgReplaceMessage;
exports.MsgSendMessage = MsgSendMessage;
exports.MsgSendMessageWithCaller = MsgSendMessageWithCaller;
exports.MsgSetMaxBurnAmountPerMessage = MsgSetMaxBurnAmountPerMessage;
exports.MsgUnlinkTokenPair = MsgUnlinkTokenPair;
exports.MsgUnpauseBurningAndMinting = MsgUnpauseBurningAndMinting;
exports.MsgUnpauseSendingAndReceivingMessages = MsgUnpauseSendingAndReceivingMessages;
exports.MsgUpdateAttesterManager = MsgUpdateAttesterManager;
exports.MsgUpdateMaxMessageBodySize = MsgUpdateMaxMessageBodySize;
exports.MsgUpdateOwner = MsgUpdateOwner;
exports.MsgUpdatePauser = MsgUpdatePauser;
exports.MsgUpdateSignatureThreshold = MsgUpdateSignatureThreshold;
exports.MsgUpdateTokenController = MsgUpdateTokenController;
exports.getCosmosGasAmountForMessage = getCosmosGasAmountForMessage;
exports.getEncodeObjectFromCosmosMessage = getEncodeObjectFromCosmosMessage;
exports.getEncodeObjectFromCosmosMessageInjective = getEncodeObjectFromCosmosMessageInjective;
